import {
  FilterTagsWrapper,
  FilterTagsScrollableWrapper,
  ClearAllTagsContent,
  FilterTagContent,
  FilterTag,
  Tags,
  FilterLabel,
  DismissIcon,
} from './FilterTags.styled';
import { SingleTicketTransformed } from 'src/components/Tickets/models/Tickets.interface';
import { useMemo } from 'react';
import { useServiceDeskContext } from 'src/context/ServiceDesk/ServiceDeskContext';

export const FilterTags = () => {
  const { filterOptions, deleteAllFilters, deleteSingleFilter } =
    useServiceDeskContext();
  const isAtLeastOneChecked = useMemo(
    () =>
      Object.values(filterOptions)?.some((options) =>
        options.some((op) => op.checked)
      ),
    [filterOptions]
  );

  return (
    <FilterTagsWrapper>
      {isAtLeastOneChecked && (
        <>
          <ClearAllTagsContent>
            <FilterLabel onClick={deleteAllFilters}>
              clear all filters
            </FilterLabel>
          </ClearAllTagsContent>
          <FilterTagsScrollableWrapper>
            {Object.entries(filterOptions)?.map(([columnId, options]) => (
              <Tags key={columnId}>
                {options.map((op) => {
                  const { label, checked } = op;
                  if (checked) {
                    return (
                      <FilterTag key={label}>
                        <FilterTagContent>
                          <FilterLabel>{label}</FilterLabel>
                          <DismissIcon
                            onClick={() =>
                              deleteSingleFilter(
                                columnId as keyof SingleTicketTransformed,
                                label
                              )
                            }
                          />
                        </FilterTagContent>
                      </FilterTag>
                    );
                  }
                })}
              </Tags>
            ))}
          </FilterTagsScrollableWrapper>
        </>
      )}
    </FilterTagsWrapper>
  );
};
